export const UET_ID = process.env.NEXT_PUBLIC_UET_ID;

export const MIXPANEL_PROJECT_TOKEN =
  process.env.NEXT_PUBLIC_MIXPANEL_PROJECT_TOKEN || '99b136e107efb941c6b779aa2f034804';
